import { render, staticRenderFns } from "./SelfServicePerformanceMonitoring.vue?vue&type=template&id=2b01790b"
import script from "./SelfServicePerformanceMonitoring.vue?vue&type=script&lang=js"
export * from "./SelfServicePerformanceMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports